import { FC } from 'react';

import './index.scss';

const SkeletonImage: FC = () => {
  return <div className="skeleton-img"></div>;
};

export default SkeletonImage;
